import React,{useState} from 'react';

const CreditLimitIncrease = ({ onNext }) => {
  const [clickedButton, setClickedButton] = useState(null);
  const handleClick = (e) => {
    const buttonValue = e.target.value;
    setClickedButton(buttonValue);
    onNext(buttonValue);
  };
  return(
  <>
    <div className="qs-card__head"><h2 className="qs-card__title">Credit Limit Increased Without Checks?</h2></div>
    <div className="qs-card__body">
      <p className="qs-card__sub">Did the lender increase your credit limit without reassessing your financial situation or asking for updated income and expenditure details?</p>
      <div className="qs-actions">
        <button 
          type="button" 
          value={419}
          className={`qs-btn qs-btn--optn ${clickedButton == '419' ? 'btn-active' : ''}`} 
          onClick={handleClick}>
            Yes</button>
        <button 
          type="button" 
          value={420}
          className={`qs-btn qs-btn--optn ${clickedButton == '420' ? 'btn-active' : ''}`} 
          onClick={handleClick}>
            No</button>
      </div>
    </div>
  </>
);
}

export default CreditLimitIncrease;
